//  ----------      START   IMPORT  BLOCK       ----------
import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Card, Spinner, Button } from 'react-bootstrap';
import { 
  FaCheckCircle, 
  FaExclamationTriangle, 
  FaInstagram, 
  FaTiktok, 
  FaTwitter, 
  FaYoutube 
} from 'react-icons/fa';
import SocialFooter from '../SocialFooter/SocialFooter';
//  Context
import { useConfirmEmail } from '../../../../../API/Hooks/useConfirmEmail';
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Utils
import ExternalLink from '../../../../../Utils/externalLink';
//  Config
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
import { VocabConfirmEmail } from '../../../../../ConfigFiles/multilingual/VocabConfirmEmail';
import { VocabSocials } from '../../../../../ConfigFiles/multilingual/VocabSocials';
import BaseLayout from '../BaseLayout/BaseLayout';
import './ConfirmEmail.css';
//  ----------      END   IMPORT  BLOCK       ----------

const ConfirmEmail = () => {
  const { lan } = useLanguage();
  const { confirm, isLoading, error, isSuccess } = useConfirmEmail();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      confirm(token);
    }
  }, [token, confirm]);

  return (
    <BaseLayout>
      <Container className="d-flex align-items-center justify-content-center confirm-page-container">
        <Card className="confirm-card shadow-lg border-0">
          <Card.Body className="p-5 text-center">
            
            {/* 1. STATUS SECTION */}
            {isLoading && (
              <div className="py-4">
                <Spinner animation="border" variant="primary" className="mb-3" />
                <p className="text-muted">{VocabConfirmEmail.verifying[lan]}</p>
              </div>
            )}

            {isSuccess && (
              <div className="status-content">
                <FaCheckCircle className="status-icon text-success mb-3" />
                <h3 className="fw-bold mb-2">{VocabConfirmEmail.verify_success_tittle[lan]}</h3>
                <p className="text-muted mb-4">{VocabConfirmEmail.verify_success_message[lan]}</p>
                <Button 
                  variant="primary" 
                  size="lg" 
                  className="w-100 mb-4 rounded-pill py-2 shadow-sm"
                  onClick={() => navigate(FRONTEND_ROUTES.auth)}
                >
                  {VocabConfirmEmail.go_to_login[lan]}
                </Button>
              </div>
            )}

            {error && (
              <div className="status-content">
                <FaExclamationTriangle className="status-icon text-danger mb-3" />
                <h3 className="fw-bold mb-2">{VocabConfirmEmail.verify_failed_tittle[lan]}</h3>
                <p className="text-muted mb-4">{error}</p>
                <Button 
                  variant="outline-secondary" 
                  className="w-100 mb-4 rounded-pill"
                  onClick={() => navigate(FRONTEND_ROUTES.landing)}
                >
                  {VocabConfirmEmail.go_to_dashboard[lan]}
                </Button>
              </div>
            )}

            {/* SOCIAL FOOTER */}
            <SocialFooter/>
          </Card.Body>
        </Card>
      </Container>
    </BaseLayout>
  );
};

export default ConfirmEmail;